import { ItemSuppliersSummary } from '../../../interfaces/item-suppliers-summary';
import { PurchaseSupplier, PurchaseSupplierLinkStatus } from '../../../interfaces/purchase-supplier';

const SOURCE_LABELS: Record<string, string> = {
  Manual: 'Manual',
  'Integração': 'Integração',
  eBarn: 'eBarn',
  'eBarn CotAI': 'Cotai',
  'eBarn Cotai': 'Cotai',
  'Trading Parceiro': 'Vendedor Parceiro'
};

/** Rótulo de exibição da origem do fornecedor; origem desconhecida aparece como veio. */
export function supplierSourceLabel(source: string | null | undefined): string | undefined {
  return source ? (SOURCE_LABELS[source] ?? source) : undefined;
}

/** Monta os dados do tooltip de fornecedores de um item (tabela de itens, dialog de unificação). */
export function buildItemSuppliersSummary(
  productName: string,
  suppliers: PurchaseSupplier[] | null | undefined,
  clickable: boolean
): ItemSuppliersSummary {
  return {
    productName,
    clickable,
    suppliers: (suppliers ?? []).map(supplier => {
      const source = supplier.source ?? '';
      return {
        id: supplier.id || supplier.email || supplier.name,
        name: supplier.fantasyName || supplier.name,
        email: supplier.email || undefined,
        sourceLabel: SOURCE_LABELS[source],
        fromCotai: /cotai/i.test(source),
        pendingApproval: supplier.linkStatus === PurchaseSupplierLinkStatus.PENDENTE
      };
    })
  };
}

export function hasPendingSuggestedSupplier(suppliers: PurchaseSupplier[] | null | undefined): boolean {
  return (suppliers ?? []).some(s => s.linkStatus === PurchaseSupplierLinkStatus.PENDENTE);
}
